import { FC } from "react";
import { createRoot } from "react-dom/client";

type ModalProps<T> = {
  open: boolean;
  onCloseRequest: () => void;
  onSubmit: (t: T) => void;
};

export async function renderModal<T, P extends ModalProps<T> = ModalProps<T>>(
  Component: FC<P>
) {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = createRoot(container);
  const show = (p: Pick<P, "onSubmit" | "onCloseRequest">) =>
    root.render(<Component {...(p as P)} open />);
  const hide = (
    p: Pick<P, "onSubmit" | "onCloseRequest">,
    callback?: () => void
  ) => {
    const handleClose = () => {
      root.unmount();
      document.body.removeChild(container);
      if (callback) {
        callback();
      }
    };
    root.render(
      <Component {...(p as P)} open={false} onCloseRequest={handleClose} />
    );
  };

  // eslint-disable-next-line
  // const destroy = () => {
  //   unmountComponentAtNode(container);
  //   document.body.removeChild(container);
  // };

  const noop = () => null;

  const confirmation = new Promise<T>((resolve, reject) => {
    const onSubmit = (t: T) => resolve(t);
    const onCloseRequest = () => reject();
    show({ onSubmit, onCloseRequest });
  });

  return confirmation.finally(() => {
    const onSubmit = noop;
    const onCloseRequest = noop;
    hide({ onSubmit, onCloseRequest }, () => {});
  });
}
